import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "./modal/modal";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  useAddPostageDataMutation,
  useGetMasterKeyListMutation,
} from "../redux/RTK/postageSlice";

function PostageDataCollection() {
  const [showModal, setShowModal] = useState(false);
  const [formerror, setFormerror] = useState(false);
  const { companyName, clientId, divisionNumber } = useSelector(
    (state) => state.auth
  );
  const [postageForm, setPostageForm] = useState({
    postageType: "",
    totalAmount: "",
    numberOfPieces: "",
    ratePerItem: "",
    permitNumber: "",
    orderNumber: "",
    poBoxNumber: "",
    masterNumber: "",
  });
  let environment = process.env.REACT_APP_ENV;
  const [addPostageData] = useAddPostageDataMutation();
  const navigate = useNavigate();
  const [getMasterKeyListMutation, { data: masterKeyList }] =
    useGetMasterKeyListMutation();
  console.log(
    "auth",
    useSelector((state) => state.auth)
  );
  useEffect(() => {
    getMasterKeyListMutation({ companyNumber: clientId });
  }, []);
  console.log("masterKeyList", masterKeyList);
  const getModal = (e) => {
    e.preventDefault();
    setFormerror(false); // Reset error state on each attempt

    const isPermitLov =
      postageForm.postageType === "Permit Postage Posting (BRM/BRC)";
    const isPostalStatement = postageForm.postageType === "Postal Statement";
    let isValid = false;
    //let isTotalMatch = false;

    if (postageForm.postageType === "") {
      // Rule: LOV must always be selected
      isValid = false;
    } else if (isPermitLov) {
      // Rule: For Permit LOV, all fields are required
      isValid =
        //postageForm.masterNumber !== "" &&
        postageForm.totalAmount !== "" &&
        postageForm.numberOfPieces !== "" &&
        postageForm.ratePerItem !== "";
    } else if (isPostalStatement) {
      isValid =
        postageForm.totalAmount !== "" &&
        postageForm.permitNumber !== "" &&
        postageForm.orderNumber !== "";
    } else {
      // Rule: For other LOVs, only totalAmount is required
      isValid = postageForm.totalAmount !== "";
    }

    if (isValid) {
      setShowModal(true);
    } else {
      setFormerror(true);
    }
  };
  const Confirm = async (e) => {
    e.preventDefault();
    //console.log("postageForm", postageForm);
    setShowModal(false);
    setPostageForm({
      postageType: "",
      totalAmount: "",
      numberOfPieces: "",
      ratePerItem: "",
      permitNumber: "",
      orderNumber: "",
      poBoxNumber: "",
      masterNumber: "",
    });

    const payload = {
      companyName,
      clientId,
      ...postageForm,
    };

    console.log("payload", payload);
    try {
      await addPostageData(payload).unwrap();

      // This code runs only on success
      toast.success("Postage Data submitted successfully!", {
        position: "top-right",
      });
      // Reset the form after successful submission
      setPostageForm({
        postageType: "",
        totalAmount: "",
        numberOfPieces: "",
        ratePerItem: "",
        permitNumber: "",
        orderNumber: "",
        poBoxNumber: "",
        masterNumber: "",
      });
    } catch (err) {
      // This code runs only on error
      console.error("Failed to submit postage data:", err);
      toast.error("Submission failed. Please try again.", {
        position: "top-right",
      });
    }
  };

  //back
  const goBack = (e) => {
    e.preventDefault();
    let redirectUrl =
      environment === "dev" || environment === "qa"
        ? `https://${environment}.hibbertordering.com/home`
        : `https://hibbertordering.com/home`;

    window.location.href = redirectUrl;
  };

  const goHome = () => {
    let redirectUrl =
      environment === "dev" || environment === "qa"
        ? `https://${environment}.hibbertordering.com/home`
        : `https://hibbertordering.com/home`;

    window.location.href = redirectUrl;
  };

  //clearing data
  const clearData = (e) => {
    e.preventDefault();
    setPostageForm({
      postageType: "",
      totalAmount: "",
      numberOfPieces: "",
      ratePerItem: "",
      permitNumber: "",
      orderNumber: "",
      poBoxNumber: "",
      masterNumber: "",
    });
  };

  return (
    <div>
      <ToastContainer />
      <div className="container">
        <div className="group">
          <div className="nav2 span12">
            <div className="user">
              <em style={{ fontSize: "18px" }} className="fa fa-user"></em>{" "}
              {clientId} - {divisionNumber} | {companyName}{" "}
            </div>
            <div className="bread-crumb">
              {" "}
              <Link to="" onClick={goHome}>
                <i style={{ fontSize: "18px" }} className="fa fa-home"></i> Home
              </Link>{" "}
              / Postage Data Collection{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <h1>Postage Data Collection</h1>
        <article className="card">
          <header>
            {" "}
            <i className="fa fa-paper-plane"></i>
            <label>Postage Data Collection</label>
          </header>
          <form>
            <div className="body">
              <div className="group">
                <div className="span6">
                  <div className="field">
                    <select
                      onChange={(e) =>
                        setPostageForm({
                          ...postageForm,
                          masterNumber: e.target.value,
                        })
                      }
                      value={postageForm.masterNumber}
                    >
                      <option value="">Select Jacket Number</option>
                      {masterKeyList?.responseBody &&
                        masterKeyList?.responseBody?.length > 0 &&
                        masterKeyList?.responseBody?.map((item, index) => (
                          <option key={index} value={item?.jobNumber}>
                            {item?.jobNumber}
                          </option>
                        ))}
                    </select>
                    {formerror && postageForm.masterNumber === "" && (
                      <p className="red">This field is required</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="group">
                <div className="span6">
                  <div className="field">
                    <select
                      onChange={(e) =>
                        // setPostageForm({
                        //   ...postageForm,
                        //   postageType: e.target.value,
                        // })
                        setPostageForm({
                          ...postageForm,
                          postageType: e.target.value,
                          // clear auto-populated rate when NOT Postal Statement
                          ...(e.target.value !== "Postal Statement" ||
                          e.target.value !== "Permit Postage Posting (BRM/BRC)"
                            ? {
                                ratePerItem: "",
                                numberOfPieces: "",
                                totalAmount: "",
                              }
                            : {}),
                        })
                      }
                      value={postageForm.postageType}
                    >
                      <option value="">Select LOV</option>
                      <option value="PO Box Renewal">PO Box Renewal</option>
                      <option value="Permit Postage Posting (BRM/BRC)">
                        Permit Postage Posting (BRM/BRC)
                      </option>
                      <option value="Postal Statement">Postal Statement</option>
                    </select>
                    {formerror && postageForm.postageType === "" && (
                      <p className="red">This field is required</p>
                    )}
                  </div>
                </div>

                <div className="span6">
                  <div className="field">
                    <input
                      className="has-error"
                      type="text"
                      placeholder="Total Amount "
                      value={postageForm.totalAmount}
                      maxLength={10}
                      onChange={(e) => {
                        const { value } = e.target;
                        // Allow only numbers and a single decimal point
                        if (/^\d*\.?\d{0,3}$/.test(value)) {
                          // setPostageForm({
                          //   ...postageForm,
                          //   totalAmount: value,
                          // });
                          const pieces = postageForm.numberOfPieces;
                          const newForm = {
                            ...postageForm,
                            totalAmount: value,
                          };
                          if (
                            postageForm.postageType === "Postal Statement" &&
                            value !== "" &&
                            pieces &&
                            pieces !== "0"
                          ) {
                            const totalNum = parseFloat(value);
                            const piecesNum = parseFloat(pieces);
                            if (
                              !isNaN(totalNum) &&
                              !isNaN(piecesNum) &&
                              piecesNum > 0
                            ) {
                              const rate = totalNum / piecesNum;
                              const truncated = Math.floor(rate * 1000) / 1000;
                              newForm.ratePerItem = Number.isFinite(truncated)
                                ? truncated.toFixed(3)
                                : "";
                            }
                          } else if (
                            postageForm.postageType === "Postal Statement"
                          ) {
                            // if Postal Statement but missing pieces, clear rate
                            newForm.ratePerItem = "";
                          }
                          setPostageForm(newForm);
                        }
                      }}
                    />
                    {formerror && postageForm.totalAmount === "" && (
                      <p className="red">This field is required</p>
                    )}
                  </div>
                </div>
                {(postageForm.postageType ===
                  "Permit Postage Posting (BRM/BRC)" ||
                  postageForm.postageType === "Postal Statement") && (
                  <>
                    <div className="span6">
                      <div className="field">
                        <input
                          className="has-error"
                          type="text"
                          maxLength={9}
                          placeholder="Number of Piece"
                          value={postageForm.numberOfPieces}
                          onChange={(e) => {
                            const { value } = e.target;
                            // Allow only whole numbers
                            if (/^[0-9]*$/.test(value)) {
                              // setPostageForm({
                              //   ...postageForm,
                              //   numberOfPieces: value,
                              // });
                              // compute ratePerItem when totalAmount is present and non-zero
                              const total = postageForm.totalAmount;
                              const newForm = {
                                ...postageForm,
                                numberOfPieces: value,
                              };
                              if (
                                postageForm.postageType ===
                                  "Postal Statement" &&
                                value !== "" &&
                                total &&
                                value !== "0"
                              ) {
                                const totalNum = parseFloat(total);
                                const piecesNum = parseFloat(value);
                                if (
                                  !isNaN(totalNum) &&
                                  !isNaN(piecesNum) &&
                                  piecesNum > 0
                                ) {
                                  const rate = totalNum / piecesNum;
                                  const truncated =
                                    Math.floor(rate * 1000) / 1000;
                                  newForm.ratePerItem = Number.isFinite(
                                    truncated
                                  )
                                    ? truncated.toFixed(3)
                                    : "";
                                }
                              } else if (
                                postageForm.postageType === "Postal Statement"
                              ) {
                                // clear rate if total not provided
                                newForm.ratePerItem = "";
                              }
                              setPostageForm(newForm);
                            }
                          }}
                        />
                        {formerror && postageForm.numberOfPieces === "" && (
                          <p className="red">This field is required</p>
                        )}
                      </div>
                    </div>
                    <div className="span6">
                      <div className="field">
                        <input
                          className="has-error"
                          type="text"
                          placeholder="Rate per Item"
                          disabled={postageForm.postageType === "Postal Statement"}
                          value={postageForm.ratePerItem}
                          maxLength={10}
                          onChange={(e) => {
                            const { value } = e.target;
                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d{0,3}$/.test(value)) {
                              setPostageForm({
                                ...postageForm,
                                ratePerItem: value,
                              });
                            }
                          }}
                        />
                        {formerror && postageForm.ratePerItem === "" && (
                          <p className="red">This field is required</p>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {(postageForm.postageType === "Postal Statement" ||
                  postageForm.postageType ===
                    "Permit Postage Posting (BRM/BRC)") && (
                  <>
                    <div className="span6">
                      <div className="field">
                        <input
                          className="has-error"
                          type="text"
                          placeholder="Permit Number"
                          value={postageForm.permitNumber}
                          maxLength={10}
                          onChange={(e) => {
                            const { value } = e.target;
                            setPostageForm({
                              ...postageForm,
                              permitNumber: value,
                            });
                          }}
                        />
                        {formerror && postageForm.permitNumber === "" && (
                          <p className="red">This field is required</p>
                        )}
                      </div>
                    </div>
                    <div className="span6">
                      <div className="field">
                        <input
                          className="has-error"
                          type="text"
                          placeholder="Order Number"
                          value={postageForm.orderNumber}
                          maxLength={10}
                          onChange={(e) => {
                            const { value } = e.target;
                            // Allow only numbers and a single decimal point
                            if (/^[a-zA-Z0-9]*$/.test(value)) {
                              setPostageForm({
                                ...postageForm,
                                orderNumber: value,
                              });
                            }
                          }}
                        />
                        {formerror && postageForm.orderNumber === "" && (
                          <p className="red">This field is required</p>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {postageForm.postageType === "PO Box Renewal" && (
                  <>
                    <div className="span6">
                      <div className="field">
                        <input
                          className="has-error"
                          type="text"
                          placeholder="PO Box Number"
                          value={postageForm.poBoxNumber}
                          maxLength={10}
                          onChange={(e) => {
                            const { value } = e.target;
                            setPostageForm({
                              ...postageForm,
                              poBoxNumber: value,
                            });
                          }}
                        />
                        {formerror && postageForm.poBoxNumber === "" && (
                          <p className="red">This field is required</p>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="group">
                <div className="span12">
                  <button className="btn-blue right" onClick={getModal}>
                    Submit
                  </button>
                  <button className="btn-red right" onClick={clearData}>
                    clear
                  </button>
                  <button className="btn-red right" onClick={goBack}>
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </form>
        </article>
        <div className="clear"></div>
        {showModal && (
          <Modal
            setShowModal={setShowModal}
            props={postageForm}
            Confirm={Confirm}
          />
        )}
      </div>
    </div>
  );
}

export default PostageDataCollection;
